function importAll(r) {
    r.keys().forEach(r)
}

importAll(require.context("../../components", true, /\.js$/))


// WEBPACK FOOTER //
// ./app/javascript/packs/components.js